import React from 'react';
// import PropTypes from "prop-types";
import styles from './SearchViewSwitch.module.scss';
import { useContextState } from '../StateProvider';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';

const SearchViewSwitch = () => {
    const { t } = useTranslation('common');
    const [{ view } = {}, dispatch] = useContextState();

    const handleClick = (view) => {
        dispatch({ type: 'set_view', payload: view });
    };

    return (
        <div className={styles['SearchViewSwitch']}>
            <div className={styles['SearchViewSwitch__Buttons']}>
                <button
                    onClick={() => handleClick('grid')}
                    aria-pressed={view !== 'list'}
                    className={styles['SearchViewSwitch__Grid']}>
                    <span className="sr-only">{t('search.switchGrid')}</span>
                </button>
                <button
                    onClick={() => handleClick('list')}
                    aria-pressed={view === 'list'}
                    className={styles['SearchViewSwitch__List']}>
                    <span className="sr-only">{t('search.switchList')}</span>
                </button>
            </div>
        </div>
    );
};

SearchViewSwitch.propTypes = {};

export default SearchViewSwitch;
